import { render } from "./cart-slideout.vue?vue&type=template&id=c40e54d4"
import script from "./cart-slideout.vue?vue&type=script&lang=js"
export * from "./cart-slideout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__